import translate from './date-group.language';

class DateGroupController {
	constructor() {
		this.translate = translate;
	}

	$onInit() {
		this.selectedDate = this.selectedDate || 'any';
	}

	/*
     * Change selected date
     */
	changeDate(date) {
		if (this.selectedDate !== date) {
			this.selectedDate = date;
			if (angular.isFunction(this.onChange))
				this.onChange({
					$event: {
						value: this.selectedDate
					}
				});
		}
	}
}

export default DateGroupController;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/date-group/date-group.controller.js